import _ from 'lodash'
import Moment from 'moment'

/**
 * Converts consumer data from camelCase to snake_case and processes address array
 * @param {Object} consumer - The consumer data object
 * @returns {Object} - Processed user info object
 */
export const convertConsumerToUserInfo = consumer => {
  if (!consumer) return {}

  // Convert camelCase to snake_case
  const snakeCaseObj = _.mapKeys(consumer, (value, key) => {
    return _.snakeCase(key)
  })

  // Process address array if it exists
  if (snakeCaseObj.addresses && Array.isArray(snakeCaseObj.addresses)) {
    const mainAddress = snakeCaseObj.addresses.find(addr => addr.main) || snakeCaseObj.addresses[0]
    if (mainAddress) {
      snakeCaseObj.address = {
        id: mainAddress.id,
        city: mainAddress.cityId,
        city_name: mainAddress.cityName,
        complement: mainAddress.complement,
        country: mainAddress.country,
        federative_unit: mainAddress.federativeUnit,
        landmark: mainAddress.landmark,
        neighborhood: mainAddress.neighborhood,
        number: mainAddress.number,
        postal_code: mainAddress.postalCode,
        street: mainAddress.street
      }
    }
    delete snakeCaseObj.addresses
  }

  // Format birth date if it exists
  if (snakeCaseObj.birth_date) {
    snakeCaseObj.birth_date = Moment(snakeCaseObj.birth_date, 'YYYY-MM-DD').format('DD-MM-YYYY')
  }
  if (snakeCaseObj.name && snakeCaseObj.person_type === 'NATURAL') {
    snakeCaseObj.surname = snakeCaseObj.name.split(' ').slice(1).join(' ')
    snakeCaseObj.name = snakeCaseObj.name.split(' ')[0]
  }

  return snakeCaseObj
}
